import DOMAIN from 'constants/domains'
import { HistoryStackContext } from 'contexts/HistoryStackContext'
import React, { useCallback, useContext } from 'react'
import { transitionWithAction } from 'utils/commonUtils'
import { getDomain ,isKsDomain , getKsClientLowerCase , isSaficDomain} from 'utils/domain'

import Button from './Button'
import {
  useJwtStateKey,
  useEditingItemStateKey,
  useQNStateKey,
} from '../../../utils/commonHooks'

/**
 * 再読み込みボタン
 */
const ReloadButton: React.FC = () => {
  const buttonLabel = '画面を再読み込みする'
  const historyStackContext = useContext(HistoryStackContext)

  const urlParams = React.useMemo(() => {
    const client = getKsClientLowerCase() !== undefined ? getKsClientLowerCase() : isSaficDomain() ? 'sn' :{ [DOMAIN.SJ]: 'sjr'}[getDomain()]
    return { client, line: 'direct', from: '9' }
  }, [getDomain()])

  const reloadOnClick = useCallback((): void => {
    transitionWithAction(historyStackContext, buttonLabel, () => {
      const searchParams = new URLSearchParams(urlParams).toString()
      // エラー画面で再読み込みボタンを押下したときは汎用URLで再度QNにアクセスを行う
      localStorage.removeItem(useQNStateKey)
      localStorage.removeItem(useEditingItemStateKey)
      localStorage.removeItem(useJwtStateKey)
      window.location.href = `${window.location.origin}/?${searchParams}`
    })
  }, [urlParams])

  const withArrow = isKsDomain() ? true : isSaficDomain() ? false :{
    [DOMAIN.SJ]: true,
  }[getDomain()]

  return (
    <Button
      background="var(--color-background)"
      color="var(--color-main)"
      bold
      onClick={reloadOnClick}
      withArrow={withArrow}
    >
      {buttonLabel}
    </Button>
  )
}

export default ReloadButton
